import React, {Component} from 'react'



export default class GetStartedWidget extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let className = 'jumbotron clearfix'+' '+this.props.className
    return (
      <div className={className}>
        <h1 className='hero-heading animated'> {this.props.heading} </h1>
        <p className='hero-subheading'> {this.props.content}</p>
        <div id='children'>
          { this.props.children }
        </div>

      </div>
    )

  }
}



/** WEBPACK FOOTER **
 ** ./src/components/getstarted/GetStartedWidget.js
 **/